export default __webpack_public_path__ + "static/media/chat_admin.45fdd386.mp4";